import { apiService } from "@/common/api.service.js";

export default {
  // Corporate plans
  getAllCorporatePlans() {
    const endpoint = `/api/corporate-plan-all/`;
    return apiService(endpoint);
  },

  corporatePlanData(planId) {
    const endpoint = `/api/corporate-plans/${planId}/`;
    return apiService(endpoint);
  },

  corporatePlanCreate(payload) {
    const endpoint = `/api/corporate-plan-create/`;
    return apiService(endpoint, "POST", payload);
  },

  corporatePlanUpdate(payload) {
    const endpoint = `/api/corporate-plan-update/${payload.id}/`;
    return apiService(endpoint, "PATCH", payload);
  },

  corporateSitePlans(payload) {
    const endpoint = `/api/attach-site-plans/corporate/${payload.id}/${payload.company}/`;
    return apiService(endpoint);
  },

  createCorporateSitePlanRelation(payload) {
    const endpoint = `/api/corporate-site-plan-create/${payload.id}/`;
    return apiService(endpoint, "POST", payload);
  },

  corporatePlanCarbonTracker(payload) {
    const endpoint = `/api/corporate-plan-carbon-tracker/${payload.id}/`;
    return apiService(endpoint);
  },

  corporatePlanCarbonTrackerUpdate(payload) {
    const endpoint = `/api/corporate-plan-carbon-tracker/${payload.id}/`;
    return apiService(endpoint, "POST", payload);
  },
};
